module.exports = __webpack_public_path__ + "media/images/clickworker_com/f2a_step_2_de-44789f9d324030eb81c1dd0f266f2aa4.png";